/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  SchemaValidationErrorResponse,
  SearchParams,
  SearchResults
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Search the catalogues
 */
export const search = (
    params: MaybeRefOrGetter<SearchParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<SearchResults>(
      {url: `/search`, method: 'GET',
        params, signal
    },
      );
    }




export const getSearchQueryKey = (params?: MaybeRefOrGetter<SearchParams>,) => {
    return [
    'search', ...(params ? [params] : [])
    ] as const;
    }


export const getSearchQueryOptions = <TData = Awaited<ReturnType<typeof search>>, TError = ErrorType<SchemaValidationErrorResponse>>(params: MaybeRefOrGetter<SearchParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof search>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getSearchQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof search>>> = ({ signal }) => search(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof search>>, TError, TData>
}

export type SearchQueryResult = NonNullable<Awaited<ReturnType<typeof search>>>
export type SearchQueryError = ErrorType<SchemaValidationErrorResponse>


/**
 * @summary Search the catalogues
 */

export function useSearch<TData = Awaited<ReturnType<typeof search>>, TError = ErrorType<SchemaValidationErrorResponse>>(
 params: MaybeRefOrGetter<SearchParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof search>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSearchQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






